import React from 'react'
import t from 'helpers/I18n'
import PropTypes from 'prop-types'
import BaseParagraph from "components/base-components/base-paragraph";
import illustration from "components/../assets/svg/idsvg.svg"
import BaseButton from "components/base-components/base-button";
import StepsWrapper from "steps/steps-wrapper";
import StepsLoader from "steps/steps-loader";
import { AppDataContext } from '../../../contexts/app-data';


const IntroIdStep = () => {
    const lang = localStorage.getItem('language')

         React.useEffect(() => {
            if (window.PageBus) {
                    window.PageBus.publish("analyticsServices", {
pageID: "onboarding",
stepSeq: "2",
stepName: "financial info:id verification explanation",
flowType: "sales",
flowName: "onboarding",
productName: "onboarding",
trackMethod: "flow"
                    }
                );
            }

     }, [])
    const { state, dispatch } = React.useContext(AppDataContext)

    return (
        <div className={"intro-step"}>
            {/* <StepsWrapper stepGroupTitle={t('general.id_card')} loaded={0.1} title={t('general.open_vue_pro_account')}> */}
            <StepsWrapper stepGroupTitle={t('general.id_card')} loaded={0.1}>
                <StepsLoader>

                    <BaseParagraph  illustration={illustration} />
                    <BaseParagraph  align={"center"} >
                        <h3>{ t('financial_infos.financial_info_id_verification_explanation.title')}</h3>
                        <p>{ t('financial_infos.financial_info_id_verification_explanation.text')}</p>
                    </BaseParagraph>


                    <div className={"footer-action"} style={{bottom: state.footer_height}}>
                        <BaseButton caption={t('general.continue')} link={`/${lang.toLowerCase()}/legal-steps/id-card`} />
                    </div>
                </StepsLoader>
            </StepsWrapper>
        </div>

    )
}

IntroIdStep.propTypes = {
    name: PropTypes.string
}

IntroIdStep.defaultProps = {
    name: "Step02"
}


export default IntroIdStep